
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    viewMode();
    localizeEnglishFacetValues(this);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const countContainerMobile = document.getElementById('ProductCountMobile');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    if (countContainerMobile) {
      countContainerMobile.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

      let container = document.getElementById('ProductGridContainer');
      let headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      let posTop = container.offsetTop - headerHeight - 50;
      window.scrollTo({ top: posTop, behavior: "smooth" });
      
    viewMode();
  }

  static renderProductCount(html) {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(html, 'text/html');

    const productCountElement = parsedHtml.getElementById('ProductCount');
    const productCountDesktopElement = parsedHtml.getElementById('ProductCountDesktop');
    const productCountMobileElement = parsedHtml.getElementById('ProductCountMobile');
    const productCountActiveElement = parsedHtml.getElementById('ProductCountActive');
    const countNewActive = productCountActiveElement ? productCountActiveElement.innerHTML : '0';
    

    const updateContainer = (containerId, count) => {
        const container = document.getElementById(containerId);
        if (container) {
            container.innerHTML = count;
            container.classList.remove('loading');
        }
    };

    if (productCountElement) {
        updateContainer('ProductCount', productCountElement.innerHTML);
    }
    if (productCountDesktopElement) {
        updateContainer('ProductCountDesktop', productCountDesktopElement.innerHTML);
    }
    if (productCountMobileElement) {
        updateContainer('ProductCountMobile', productCountMobileElement.innerHTML);
    }

    const countActive = document.getElementById('ProductCountActive');
    if (countActive) {
        countActive.innerHTML = countNewActive;
    }

    const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach(spinner => spinner.classList.add('hidden'));
  }


  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          console.log(previousElementClassName, previousElementId);
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
    reinitializeCustomElements();
    viewMode();
    localizeEnglishFacetValues();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');


    const searchParams = this.createFilteredSearchParams(event.target.closest('form'));


    if (event.srcElement.className === 'mobile-facets__checkbox') {
        this.onSubmitForm(searchParams.toString(), event);
    } else {
        const forms = [];
        const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
        sortFilterForms.forEach((form) => {
            if (!isMobile) {
                if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                    forms.push(this.createFilteredSearchParams(form).toString());
                }
            } else if (form.id === 'FacetFiltersFormMobile') {
                forms.push(this.createFilteredSearchParams(form).toString());
            }
        });
        this.onSubmitForm(forms.join('&'), event);
    }
  }


  createFilteredSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);


    if (searchParams.has("filter.v.price.gte") && searchParams.get("filter.v.price.gte") === "0") {
        searchParams.delete("filter.v.price.gte");
    }

    const priceSlider = document.querySelector(".price-slider-range");
    if (priceSlider) {
        const maxPrice = parseFloat(priceSlider.dataset.max);
        
        if (searchParams.has("filter.v.price.lte") && searchParams.get("filter.v.price.lte") === maxPrice.toString()) {
            searchParams.delete("filter.v.price.lte");
        }
    }

    return searchParams; 
  }


  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
    this.priceSlider();
  }
  connectedCallback(){
    this.priceSlider();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }


  priceSlider() {
      const sliderRange = this.querySelector(".price-slider-range");
      if (!sliderRange) return;

      const [minInput, maxInput] = this.querySelectorAll('input');
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      const event = new CustomEvent('input');

      const minValue = parseFloat(minInput.value.replace(',', '')) || 0;
      const maxValue = parseFloat(maxInput.value.replace(',', '')) || parseFloat(sliderRange.dataset.max);

      if (sliderRange.noUiSlider) {
          sliderRange.noUiSlider.destroy();
      }
      const direction = document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr';

      noUiSlider.create(sliderRange, {
          start: [minValue, maxValue],
          direction: direction,
          connect: true,
          step: 10,
          handleAttributes: [
            { 'aria-label': 'lower' },
            { 'aria-label': 'upper' },
          ],
          range: {
              'min': 0,
              'max': parseFloat(sliderRange.dataset.max)
          }
      });
      
      sliderRange.noUiSlider.on('update', (values) => {
          minInput.value = Math.round(parseFloat(values[0]));
          maxInput.value = Math.round(parseFloat(values[1]));
      });
      let debounceTimer;

      sliderRange.noUiSlider.on('set', (values) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          minInput.value = Math.round(parseFloat(values[0]));
          maxInput.value = Math.round(parseFloat(values[1]));
          form.querySelector('form')?.dispatchEvent(event);
        }, 100);
      });

  }
  
}

customElements.define('price-range', PriceRange);


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


function reinitializeCustomElements() {
  const container = document.querySelector('.section-collection-products-grid');
  if (!container) return;

  container.querySelectorAll('collapsible-details').forEach((element) => {
    const isOpen = element.querySelector('details')?.open;
    
    const newElement = element.cloneNode(true);
    element.replaceWith(newElement);

    requestAnimationFrame(() => {
      if (typeof newElement.connectedCallback === 'function') {
        newElement.connectedCallback();
      }

      const newDetails = newElement.querySelector('details');
      if (isOpen) {
        newDetails.open = true;
      }
    });
  });
}


function localizeEnglishFacetValues(root = document) {
  if (!window.location.pathname.startsWith('/en')) return;

  const labels = {
    'Yuvarlak': 'Round',
    'Baget': 'Baguette',
    'Oval': 'Oval',
    'Damla': 'Pear',
    'Markiz': 'Marquise',
    'Prenses': 'Princess',
    'Emerald': 'Emerald Cut',
    'Trapez': 'Trapezoid',
    'Drop': 'Drop',
    'Drumstick': 'Drumstick',
    'Sarı Altın': 'Yellow Gold',
    'Beyaz Altın': 'White Gold',
    'Rose Altın': 'Rose Gold',
    'Rose - Beyaz Altın': 'Rose - White Gold',
    'Sarı - Rose - Beyaz Altın': 'Yellow - Rose - White Gold',
    '2,00 ct ve üzeri': '2.00 ct and above',
    'Kalp': 'Heart',
    'Yüzükler': 'Rings',
    'Tektaş': 'Solitaire'
  };

  root.querySelectorAll('.facet-checkbox__text-label, [data-tooltip]').forEach((element) => {
    const value = element.classList.contains('facet-checkbox__text-label')
      ? element.textContent.trim()
      : element.dataset.tooltip?.trim();

    const translated = labels[value] || value?.replace(/(\d),(\d)/g, '$1.$2');
    if (!translated || translated === value) return;

    if (element.classList.contains('facet-checkbox__text-label')) {
      element.textContent = translated;
    } else {
      element.dataset.tooltip = translated;
    }
  });

  root.querySelectorAll('.facets__summary-label').forEach((element) => {
    Array.from(element.childNodes).forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) return;
      const value = node.textContent.trim();
      if (value === 'Takı Türü') node.textContent = node.textContent.replace(value, 'Jewelry Type');
    });
  });

  root.querySelectorAll('.active-facets__button-inner').forEach((element) => {
    Array.from(element.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const value = node.textContent.trim();
        if (labels[value]) node.textContent = node.textContent.replace(value, labels[value]);
      }
    });
  });
}

function localizeEnglishCollectionGuides() {
  if (!window.location.pathname.startsWith('/en')) return;

  const textMap = {
    'Tektaş Yüzük Seçenekleri': 'Solitaire Diamond Ring Options',
    'Tektaş pırlanta yüzük seçerken nelere dikkat edilmeli?': 'What Should You Consider When Choosing a Solitaire Diamond Ring?',
    '0,30 karat tektaş pırlanta yüzük günlük kullanım için uygun mudur?': 'Is a 0.30 carat solitaire diamond ring suitable for everyday wear?',
    '0,30 karat tektaş yüzük seçerken hangi özellikler karşılaştırılmalı?': 'Which features should I compare when choosing a 0.30 carat solitaire ring?',
    '0,30 karat tektaş yüzükte sertifika neden önemlidir?': 'Why is certification important for a 0.30 carat solitaire ring?'
  };
  const hrefMap = {
    '/collections/tektas-pirlanta-yuzukler': ['/en/collections/tektas-pirlanta-yuzukler', 'All Solitaire Diamond Rings'],
    '/collections/0-40-karat-pirlanta-tektas-yuzuk': ['/en/collections/0-40-karat-pirlanta-tektas-yuzuk', '0.40 Carat Solitaire Diamond Rings'],
    '/collections/0-50-karat-tektas-pirlanta-yuzuk': ['/en/collections/0-50-karat-tektas-pirlanta-yuzuk', '0.50 Carat Solitaire Diamond Rings'],
    '/collections/0-60-karat-tektas-pirlanta-yuzuk': ['/en/collections/0-60-karat-tektas-pirlanta-yuzuk', '0.60 Carat Solitaire Diamond Rings'],
    '/collections/0-70-karat-pirlanta-tektas-yuzuk': ['/en/collections/0-70-karat-pirlanta-tektas-yuzuk', '0.70 Carat Solitaire Diamond Rings'],
    '/collections/0-90-karat-tektas-pirlanta-yuzuk': ['/en/collections/0-90-karat-tektas-pirlanta-yuzuk', '0.90 Carat Solitaire Diamond Rings'],
    '/collections/1-00-karat-tektas-pirlanta-yuzuk': ['/en/collections/1-00-karat-tektas-pirlanta-yuzuk', '1.00 Carat Solitaire Diamond Rings'],
    '/collections/oval-tektas-pirlanta-yuzukler': ['/en/collections/oval-tektas-pirlanta-yuzukler', 'Oval Solitaire Diamond Rings'],
    '/collections/evlilik-teklifi': ['/en/collections/evlilik-teklifi', 'Engagement Rings']
  };

  document.querySelectorAll('.venta-collection-hub-links h2, .venta-priority-guide h2, .collection-faq summary').forEach((element) => {
    const translated = textMap[element.textContent.trim()];
    if (translated) element.textContent = translated;
  });

  document.querySelectorAll('.venta-collection-hub-links').forEach((nav) => {
    nav.setAttribute('aria-label', 'Solitaire diamond ring options');
    nav.querySelectorAll('a').forEach((link) => {
      const mapped = hrefMap[link.getAttribute('href')];
      if (!mapped) return;
      link.href = mapped[0];
      link.textContent = mapped[1];
    });
  });

  document.querySelectorAll('.venta-priority-guide p').forEach((element) => {
    const value = element.textContent.trim();
    if (value.startsWith('Tektaş pırlanta yüzük seçimi yalnızca karat')) {
      element.textContent = 'Choosing a solitaire diamond ring involves more than carat weight. Assess the diamond’s cut, colour, clarity, setting and product-specific certificate details together. For a balanced everyday look, compare refined carat options; for a stronger centre-stone effect, compare higher weights at the same cut and quality level.';
    } else if (value.startsWith('Yüzüğün parmakta nasıl göründüğünü')) {
      element.textContent = 'Diamond shape and setting also change how a ring looks on the hand. Before deciding, review the carat, colour, clarity, gold purity and certificate details on the product page.';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(localizeEnglishCollectionGuides, 0));
} else {
  setTimeout(localizeEnglishCollectionGuides, 0);
}

function viewMode() {
  class ViewModeController {
    constructor(gridId, desktopBtnSelector, mobileBtnSelector) {
      this.grid = document.getElementById(gridId);
      this.desktopButtons = document.querySelectorAll(desktopBtnSelector);
      this.mobileButtons = document.querySelectorAll(mobileBtnSelector);

      this.desktopStorageKey = 'productDesktopViewCols';
      this.mobileStorageKey = 'productMobileViewCols';

      this.defaultDesktopCols = '4';
      this.defaultMobileCols = '2'; 

      this.currentAppliedMode = null;
      this.currentAppliedCols = null;

      this.init();
    }

    init() {
      if (!this.grid || (this.desktopButtons.length === 0 && this.mobileButtons.length === 0)) return;

      this.applyViewMode(true); 
      this.registerEvents();

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const newMode = this.getCurrentMode();
            if (newMode !== this.currentAppliedMode) {
                this.applyViewMode();
            }
        }, 150); 
      });
    }

    getCurrentMode() {
      return window.matchMedia('(min-width: 64rem)').matches ? 'desktop' : 'mobile';
    }

    getSavedCols(mode) {
      if (mode === 'desktop') {
        return localStorage.getItem(this.desktopStorageKey) || this.defaultDesktopCols;
      } else {
        return localStorage.getItem(this.mobileStorageKey) || this.defaultMobileCols;
      }
    }

    applyViewMode(forceUpdate = false) {
      if (!this.grid) return;
      const mode = this.getCurrentMode();
      const cols = this.getSavedCols(mode);


      if (forceUpdate || mode !== this.currentAppliedMode || cols !== this.currentAppliedCols) {
        if (mode === 'desktop' && this.desktopButtons.length > 0) {
          this.removeGridCols(/^lg:grid-cols-\d+$/);
          this.grid.classList.add(`lg:grid-cols-${cols}`);
          this.updateActiveButton(this.desktopButtons, cols);
        } else if (mode === 'mobile' && this.mobileButtons.length > 0) {
          this.removeGridCols(/^grid-cols-\d+$/); 
          this.grid.classList.add(`grid-cols-${cols}`);
          this.updateActiveButton(this.mobileButtons, cols);
        }

        this.currentAppliedMode = mode;
        this.currentAppliedCols = cols;
        this.restartGridAnimations();
      }
    }

    removeGridCols(regex) {
      Array.from(this.grid.classList)
        .filter(cls => regex.test(cls))
        .forEach(cls => this.grid.classList.remove(cls));
    }

    updateActiveButton(buttons, modeValue) {
      if (!buttons || buttons.length === 0) return;
      buttons.forEach(btn => {
        if (btn.getAttribute('data-view-mode') === modeValue) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }

    registerEvents() {
      if (this.desktopButtons.length > 0) {
        this.desktopButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            const value = btn.getAttribute('data-view-mode');
            localStorage.setItem(this.desktopStorageKey, value);
            this.applyViewMode(true); 
          });
        });
      }
      if (this.mobileButtons.length > 0) {
        this.mobileButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            const value = btn.getAttribute('data-view-mode');
            localStorage.setItem(this.mobileStorageKey, value);
            this.applyViewMode(true); 
          });
        });
      }
    }

    restartGridAnimations() {
      const gridElements = this.grid.querySelectorAll('.scroll-trigger, .animate--slide-in'); 
      gridElements.forEach(el => {
        el.classList.add('scroll-trigger--offscreen'); 
        el.classList.remove('scroll-trigger--cancel'); 
        if (el.hasAttribute('data-cascade')) {
            el.style.removeProperty('--animation-order');
        }
      });

      if (typeof initializeScrollAnimationTrigger === "function") {
        initializeScrollAnimationTrigger(this.grid); 
      }
    }
  }

  new ViewModeController(
    'product-grid',
    '.view-mode__button',
    '.view-mode__button-mobile'
  );
}



